// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-timeline {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.5rem;
  margin-top: 1rem;
}

.status-timeline-compact .status-timeline-label {
  font-size: 0.65rem;
}

.status-timeline-step {
  text-align: center;
  opacity: 0.45;
  transition: opacity 0.3s ease;
}

.status-timeline-step.done {
  opacity: 1;
}

.status-timeline-step.active .status-timeline-dot {
  transform: scale(1.15);
  filter: drop-shadow(0 0 6px rgba(37, 99, 235, 0.5));
}

.status-timeline-dot {
  display: block;
  font-size: 1.35rem;
  margin-bottom: 0.25rem;
  transition: transform 0.3s ease;
}

.status-timeline-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.3;
}

.status-timeline-date {
  display: block;
  font-size: 0.62rem;
  color: var(--footer-medium-gray);
  margin-top: 0.2rem;
  line-height: 1.3;
}

.status-timeline-note {
  display: block;
  font-size: 0.65rem;
  color: var(--primary-dark-blue);
  margin-top: 0.25rem;
  line-height: 1.35;
}

.status-timeline-detailed {
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

.status-timeline-detailed .status-timeline-step {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto auto;
  column-gap: 0.75rem;
  text-align: start;
  padding: 0.75rem;
  border-radius: 10px;
  background: var(--section-light-gray);
}

.status-timeline-detailed .status-timeline-dot {
  grid-row: 1 / span 3;
  align-self: center;
  font-size: 1.5rem;
}

@media (max-width: 640px) {
  .status-timeline {
    grid-template-columns: repeat(3, 1fr);
  }

  .status-timeline-detailed {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StatusTimeline.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".status-timeline {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.status-timeline-compact .status-timeline-label {\n  font-size: 0.65rem;\n}\n\n.status-timeline-step {\n  text-align: center;\n  opacity: 0.45;\n  transition: opacity 0.3s ease;\n}\n\n.status-timeline-step.done {\n  opacity: 1;\n}\n\n.status-timeline-step.active .status-timeline-dot {\n  transform: scale(1.15);\n  filter: drop-shadow(0 0 6px rgba(37, 99, 235, 0.5));\n}\n\n.status-timeline-dot {\n  display: block;\n  font-size: 1.35rem;\n  margin-bottom: 0.25rem;\n  transition: transform 0.3s ease;\n}\n\n.status-timeline-label {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.status-timeline-date {\n  display: block;\n  font-size: 0.62rem;\n  color: var(--footer-medium-gray);\n  margin-top: 0.2rem;\n  line-height: 1.3;\n}\n\n.status-timeline-note {\n  display: block;\n  font-size: 0.65rem;\n  color: var(--primary-dark-blue);\n  margin-top: 0.25rem;\n  line-height: 1.35;\n}\n\n.status-timeline-detailed {\n  grid-template-columns: 1fr;\n  gap: 0.75rem;\n}\n\n.status-timeline-detailed .status-timeline-step {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto auto auto;\n  column-gap: 0.75rem;\n  text-align: start;\n  padding: 0.75rem;\n  border-radius: 10px;\n  background: var(--section-light-gray);\n}\n\n.status-timeline-detailed .status-timeline-dot {\n  grid-row: 1 / span 3;\n  align-self: center;\n  font-size: 1.5rem;\n}\n\n@media (max-width: 640px) {\n  .status-timeline {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .status-timeline-detailed {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
